export default __webpack_public_path__ + "static/swimming-pool-banner_cropped-81b8e063e57c4bccec1773375b2f6232.jpg";